// import * as React from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell, { tableCellClasses } from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { Box, Button, Menu, MenuItem, styled } from '@mui/material';
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store';
// import { fetchSellerOrders, updateOrderStatus } from '../../../Redux Toolkit/Seller/sellerOrderSlice';
// import { Order, OrderItem } from '../../../types/orderTypes';

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   '&:nth-of-type(odd)': {
//     backgroundColor: theme.palette.action.hover,
//   },
//   '&:last-child td, &:last-child th': {
//     border: 0,
//   },
// }));

// const orderStatus = [
//   { color: '#FFA500', label: 'PENDING' }, 
//   { color: '#F5BCBA', label: 'PLACED' }, 
//   { color: '#F5BCBA', label: 'CONFIRMED' },
//   { color: '#1E90FF', label: 'SHIPPED' }, 
//    { color: '#32CD32', label: 'DELIVERED' }, 
//    { color: '#FF0000', label: 'CANCELLED' },

// ];
// const orderStatusColor = {
//   PENDING: { color: '#FFA500', label: 'PENDING' }, // Orange
//   CONFIRMED:{ color: '#F5BCBA', label: 'CONFIRMED' },
//   PLACED:{ color: '#F5BCBA', label: 'PLACED' }, 
//   SHIPPED: { color: '#1E90FF', label: 'SHIPPED' }, // DodgerBlue
//   DELIVERED: { color: '#32CD32', label: 'DELIVERED' }, // LimeGreen
//   CANCELLED: { color: '#FF0000', label: 'CANCELLED' } // Red
// };

// export default function OrderTable() {
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(5);
//   const { sellerOrder } = useAppSelector(store => store);
//   const dispatch = useAppDispatch();

//   const [anchorEl, setAnchorEl] = React.useState<{ [key: number]: HTMLElement | null }>({});

//   const handleClick = (event: React.MouseEvent<HTMLElement>, orderId: number) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: event.currentTarget }));
//   };

//   const handleClose = (orderId: number) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: null }));
//   };

//   React.useEffect(() => {
//     dispatch(fetchSellerOrders(localStorage.getItem("jwt") || ""));
//   }, [dispatch]);

//   const handleUpdateOrder = (orderId: number, orderStatus: any) => {
//     dispatch(updateOrderStatus({
//       jwt: localStorage.getItem("jwt") || "",
//       orderId,
//       orderStatus,
//     }));
//     handleClose(orderId);
//   };

//   return (
//     <>
//       <h1 className='pb-5 font-bold text-xl'>All Orders</h1>

//       <TableContainer component={Paper}>
//         <Table sx={{ minWidth: 700 }} aria-label="customized table">
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Order Id</StyledTableCell>
//               <StyledTableCell>Products</StyledTableCell>
//               <StyledTableCell>Shipping Address</StyledTableCell>
//               <StyledTableCell align="right">Order Status</StyledTableCell>
//               <StyledTableCell align="right">Update</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {sellerOrder.orders.map((item: Order) => (
//               <StyledTableRow key={item.id}>
//                 <StyledTableCell align="left">{item.id}</StyledTableCell>
//                  {/* <StyledTableCell align="left">{`OD${item.id}`}</StyledTableCell> */}
//                 <StyledTableCell component="th" scope="row">
//                   <div className='flex gap-1 flex-wrap'>
//                     {item.orderItems.map((orderItem: OrderItem) =>
//                       <div key={orderItem.id} className='flex gap-5'>
//                         <img className='w-20 rounded-md' src={orderItem.product.images[0]} alt="" />
//                         <div className='flex flex-col justify-between py-2'>
//                           <h1>Title: {orderItem.product.title}</h1>
//                           <h1>Price: Rs.{orderItem.product.sellingPrice}</h1>
//                           <h1>Color: {orderItem.product.color}</h1>
//                           <h1>Size: {orderItem.size}</h1>
//                           <h1>Quantity: {orderItem.quantity}</h1>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </StyledTableCell>
//                 <StyledTableCell>
//                   <div className='flex flex-col gap-y-2'>
//                     <h1>{item.shippingAddress.name}</h1>
//                     <h1>{item.shippingAddress.address}, {item.shippingAddress.city}</h1>
//                     <h1>{item.shippingAddress.state} - {item.shippingAddress.pinCode}</h1>
//                     <h1><strong>Mobile:</strong> {item.shippingAddress.mobile}</h1>
//                   </div>
//                 </StyledTableCell>
//                 <StyledTableCell 
//                  sx={{color:orderStatusColor[item.orderStatus].color}} 
//                  align="center"> <Box sx={{borderColor:orderStatusColor[item.orderStatus].color}}  className={`border px-2 py-1 rounded-full text-xs`}>
//                   {item.orderStatus}</Box> 
//                  </StyledTableCell>
//                 <StyledTableCell align="right">
//                   <Button
//                     size='small'
//                     onClick={(e) => handleClick(e, item.id)}
//                     color='primary'
//                     className='bg-primary-color'>
//                     Status
//                   </Button>
//                   <Menu
//                     id={`status-menu ${item.id}`}
//                     anchorEl={anchorEl[item.id]}
//                     open={Boolean(anchorEl[item.id])}
//                     onClose={() => handleClose(item.id)}
//                     MenuListProps={{
//                       'aria-labelledby': `status-menu ${item.id}`,
//                     }}
//                   >
//                     {orderStatus.map((status) =>
//                       <MenuItem 
//                       key={status.label} 
//                       onClick={() => handleUpdateOrder(item.id, status.label)}>
//                         {status.label}</MenuItem>
//                     )}
//                   </Menu>
//                 </StyledTableCell>
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// }



// import * as React from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import {
//   Box,
//   Button,
//   Menu,
//   MenuItem,
//   styled,
//   FormControl,
//   InputLabel,
//   Select,
//   TextField,
//   Stack,
// } from "@mui/material";

// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import {
//   fetchSellerOrders,
//   updateOrderStatus,
// } from "../../../Redux Toolkit/Seller/sellerOrderSlice";
// import { Order, OrderItem } from "../../../types/orderTypes";
// import { api } from "../../../Config/Api";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
//   "&:last-child td, &:last-child th": { border: 0 },
// }));

// const orderStatus = [
//   { color: "#FFA500", label: "PENDING" },
//   { color: "#F5BCBA", label: "PLACED" },
//   { color: "#F5BCBA", label: "CONFIRMED" },
//   { color: "#1E90FF", label: "SHIPPED" },
//   { color: "#32CD32", label: "DELIVERED" },
//   { color: "#FF0000", label: "CANCELLED" },
// ];

// const orderStatusColor: any = {
//   PENDING: { color: "#FFA500", label: "PENDING" },
//   CONFIRMED: { color: "#F5BCBA", label: "CONFIRMED" },
//   PLACED: { color: "#F5BCBA", label: "PLACED" },
//   SHIPPED: { color: "#1E90FF", label: "SHIPPED" },
//   DELIVERED: { color: "#32CD32", label: "DELIVERED" },
//   CANCELLED: { color: "#FF0000", label: "CANCELLED" },
// };

// // Convert ANY backend shape into a safe array
// function normalizeOrders(data: any): Order[] {
//   if (!data) return [];
//   if (Array.isArray(data)) return data;
//   if (Array.isArray(data?.content)) return data.content; // Spring Page
//   if (Array.isArray(data?.orders)) return data.orders; // wrapper {orders:[]}
//   if (Array.isArray(data?.data)) return data.data; // wrapper {data:[]}
//   return [data]; // single object -> wrap
// }

// export default function OrderTable() {
//   const { sellerOrder } = useAppSelector((store) => store);
//   const dispatch = useAppDispatch();
//   const jwt = localStorage.getItem("jwt") || "";

//   // Filters (all optional)
//   const [searchBy, setSearchBy] = React.useState<"orderId" | "email">("orderId");
//   const [searchValue, setSearchValue] = React.useState<string>("");

//   const [statusFilter, setStatusFilter] = React.useState<string>("ALL");
//   const [fromDate, setFromDate] = React.useState<string>("");
//   const [toDate, setToDate] = React.useState<string>("");

//   // Search results stored separately, so default page remains same
//   const [filteredOrders, setFilteredOrders] = React.useState<Order[] | null>(
//     null
//   );
//   const [searchLoading, setSearchLoading] = React.useState<boolean>(false);

//   const [anchorEl, setAnchorEl] = React.useState<{
//     [key: number]: HTMLElement | null;
//   }>({});

//   const handleClick = (
//     event: React.MouseEvent<HTMLElement>,
//     orderId: number
//   ) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: event.currentTarget }));
//   };

//   const handleClose = (orderId: number) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: null }));
//   };

//   React.useEffect(() => {
//     // Default behavior (as before)
//     dispatch(fetchSellerOrders(jwt));
//   }, [dispatch, jwt]);

//   const handleUpdateOrder = (orderId: number, orderStatusVal: any) => {
//     dispatch(
//       updateOrderStatus({
//         jwt,
//         orderId,
//         orderStatus: orderStatusVal,
//       })
//     );
//     handleClose(orderId);
//   };

//   const hasAnyFilter =
//     (searchValue && searchValue.trim().length > 0) ||
//     statusFilter !== "ALL" ||
//     !!fromDate ||
//     !!toDate;

//   const handleApplyFilters = async () => {
//     // No filter => behave exactly like before
//     if (!hasAnyFilter) {
//       setFilteredOrders(null);
//       dispatch(fetchSellerOrders(jwt));
//       return;
//     }

//     // validate date range
//     if (fromDate && toDate && fromDate > toDate) {
//       alert("Invalid date range: 'From' date cannot be after 'To' date.");
//       return;
//     }

//     setSearchLoading(true);

//     try {
//       const params = new URLSearchParams();

//       if (statusFilter !== "ALL") params.append("status", statusFilter);
//       if (fromDate) params.append("from", fromDate);
//       if (toDate) params.append("to", toDate);

//       // Search value is optional
//       if (searchBy === "orderId") {
//         if (searchValue.trim()) params.append("orderId", searchValue.trim());

//         const res = await api.get(`/seller/orders/search?${params.toString()}`, {
//           headers: { Authorization: `Bearer ${jwt}` },
//         });

//         setFilteredOrders(normalizeOrders(res.data));
//       } else {
//         if (searchValue.trim()) params.append("email", searchValue.trim());

//         const res = await api.get(
//           `/seller/orders/search-by-user?${params.toString()}`,
//           { headers: { Authorization: `Bearer ${jwt}` } }
//         );

//         setFilteredOrders(normalizeOrders(res.data));
//       }
//     } catch (err: any) {
//       console.log("Search error", err?.response || err);
//       alert(err?.response?.data?.message || "Failed to search orders");
//       setFilteredOrders([]); // safe fallback
//     } finally {
//       setSearchLoading(false);
//     }
//   };

//   const handleClearFilters = () => {
//     setSearchBy("orderId");
//     setSearchValue("");
//     setStatusFilter("ALL");
//     setFromDate("");
//     setToDate("");
//     setFilteredOrders(null);

//     // restore original behavior
//     dispatch(fetchSellerOrders(jwt));
//   };

//   // Always safe array
//   const ordersToShow: Order[] = React.useMemo(() => {
//     if (Array.isArray(filteredOrders)) return filteredOrders;
//     if (Array.isArray(sellerOrder?.orders)) return sellerOrder.orders;
//     return [];
//   }, [filteredOrders, sellerOrder?.orders]);

//   const isLoading = Boolean(sellerOrder?.loading) || searchLoading;

//   return (
//     <>
//       <h1 className="pb-5 font-bold text-xl">All Orders</h1>

//       {/* Filter Bar */}
//       <Paper className="mb-4" sx={{ p: 2 }}>
//         <Stack
//           direction={{ xs: "column", md: "row" }}
//           spacing={2}
//           alignItems={{ md: "center" }}
//           sx={{ width: "100%" }} // ✅ take full width so input can expand (reduces gap)
//         >
//           <FormControl size="small" sx={{ minWidth: 160 }}>
//             <InputLabel id="search-by-label">Search By</InputLabel>
//             <Select
//               labelId="search-by-label"
//               value={searchBy}
//               label="Search By"
//               onChange={(e) => {
//                 setSearchBy(e.target.value as any);
//                 setSearchValue("");
//               }}
//             >
//               <MenuItem value="orderId">Order ID</MenuItem>
//               <MenuItem value="email">Email</MenuItem>
//             </Select>
//           </FormControl>

//           {/* ✅ Updated: no spinner, but numeric-only when Order ID */}
//           <TextField
//             size="small"
//             label={searchBy === "orderId" ? "Order ID (optional)" : "Email (optional)"}
//             value={searchValue}
//             onChange={(e) => {
//               const val = e.target.value;
//               if (searchBy === "orderId") {
//                 // allow only digits (no spinner)
//                 setSearchValue(val.replace(/\D/g, ""));
//               } else {
//                 setSearchValue(val);
//               }
//             }}
//             placeholder={searchBy === "orderId" ? "Enter order id" : "Enter email"}
//             inputProps={
//               searchBy === "orderId"
//                 ? { inputMode: "numeric", pattern: "[0-9]*" }
//                 : undefined
//             }
//             sx={{ minWidth: 120, flexGrow: 1 }} // ✅ wider + aligns with table width
//           />

//           <FormControl size="small" sx={{ minWidth: 180 }}>
//             <InputLabel id="status-label">Order Status</InputLabel>
//             <Select
//               labelId="status-label"
//               value={statusFilter}
//               label="Order Status"
//               onChange={(e) => setStatusFilter(e.target.value)}
//             >
//               <MenuItem value="ALL">All</MenuItem>
//               {orderStatus.map((s) => (
//                 <MenuItem key={s.label} value={s.label}>
//                   {s.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <TextField
//             size="small"
//             label="From (optional)"
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//           />

//           <TextField
//             size="small"
//             label="To (optional)"
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//           />

//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Button
//               variant="contained"
//               onClick={handleApplyFilters}
//               disabled={isLoading}
//             >
//               Apply
//             </Button>
//             <Button
//               variant="outlined"
//               onClick={handleClearFilters}
//               disabled={isLoading}
//             >
//               Clear
//             </Button>
//           </Box>
//         </Stack>
//       </Paper>

//       <TableContainer component={Paper}>
//         <Table sx={{ minWidth: 700 }} aria-label="customized table">
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Order Id</StyledTableCell>
//               <StyledTableCell>Products</StyledTableCell>
//               <StyledTableCell>Shipping Address</StyledTableCell>
//               <StyledTableCell align="right">Order Status</StyledTableCell>
//               <StyledTableCell align="right">Update</StyledTableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {ordersToShow.map((item: Order) => (
//               <StyledTableRow key={item.id}>
//                 <StyledTableCell align="left">{item.id}</StyledTableCell>

//                 <StyledTableCell component="th" scope="row">
//                   <div className="flex gap-1 flex-wrap">
//                     {item.orderItems?.map((orderItem: OrderItem) => (
//                       <div key={orderItem.id} className="flex gap-5">
//                         <img
//                           className="w-20 rounded-md"
//                           src={orderItem.product?.images?.[0]}
//                           alt=""
//                         />
//                         <div className="flex flex-col justify-between py-2">
//                           <h1>Title: {orderItem.product?.title}</h1>
//                           <h1>Price: Rs.{orderItem.product?.sellingPrice}</h1>
//                           <h1>Color: {orderItem.product?.color}</h1>
//                           <h1>Size: {orderItem.size}</h1>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </StyledTableCell>

//                 <StyledTableCell>
//                   <div className="flex flex-col gap-y-2">
//                     <h1>{item.shippingAddress?.name}</h1>
//                     <h1>
//                       {item.shippingAddress?.address},{" "}
//                       {item.shippingAddress?.city}
//                     </h1>
//                     <h1>
//                       {item.shippingAddress?.state} -{" "}
//                       {item.shippingAddress?.pinCode}
//                     </h1>
//                     <h1>
//                       <strong>Mobile:</strong> {item.shippingAddress?.mobile}
//                     </h1>
//                   </div>
//                 </StyledTableCell>

//                 <StyledTableCell
//                   sx={{ color: orderStatusColor[item.orderStatus]?.color }}
//                   align="center"
//                 >
//                   <Box
//                     sx={{ borderColor: orderStatusColor[item.orderStatus]?.color }}
//                     className="border px-2 py-1 rounded-full text-xs"
//                   >
//                     {item.orderStatus}
//                   </Box>
//                 </StyledTableCell>

//                 <StyledTableCell align="right">
//                   <Button
//                     size="small"
//                     onClick={(e) => handleClick(e, item.id)}
//                     color="primary"
//                     className="bg-primary-color"
//                     disabled={isLoading}
//                   >
//                     Status
//                   </Button>

//                   <Menu
//                     id={`status-menu ${item.id}`}
//                     anchorEl={anchorEl[item.id]}
//                     open={Boolean(anchorEl[item.id])}
//                     onClose={() => handleClose(item.id)}
//                     MenuListProps={{
//                       "aria-labelledby": `status-menu ${item.id}`,
//                     }}
//                   >
//                     {orderStatus.map((s) => (
//                       <MenuItem
//                         key={s.label}
//                         onClick={() => handleUpdateOrder(item.id, s.label)}
//                       >
//                         {s.label}
//                       </MenuItem>
//                     ))}
//                   </Menu>
//                 </StyledTableCell>
//               </StyledTableRow>
//             ))}

//             {ordersToShow.length === 0 && !isLoading && (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   No orders found
//                 </TableCell>
//               </TableRow>
//             )}

//             {isLoading && (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   Loading...
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// }


// import * as React from "react";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell, { tableCellClasses } from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import {
//   Box,
//   Button,
//   Menu,
//   MenuItem,
//   styled,
//   FormControl,
//   InputLabel,
//   Select,
//   TextField,
//   Stack,
// } from "@mui/material";

// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import {
//   fetchSellerOrders,
//   updateOrderStatus,
// } from "../../../Redux Toolkit/Seller/sellerOrderSlice";
// import { Order, OrderItem } from "../../../types/orderTypes";
// import { api } from "../../../Config/Api";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   [`&.${tableCellClasses.head}`]: {
//     backgroundColor: theme.palette.common.black,
//     color: theme.palette.common.white,
//   },
//   [`&.${tableCellClasses.body}`]: {
//     fontSize: 14,
//   },
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
//   "&:last-child td, &:last-child th": { border: 0 },
// }));

// const orderStatus = [
//   { color: "#FFA500", label: "PENDING" },
//   { color: "#F5BCBA", label: "PLACED" },
//   { color: "#F5BCBA", label: "CONFIRMED" },
//   { color: "#1E90FF", label: "SHIPPED" },
//   { color: "#32CD32", label: "DELIVERED" },
//   { color: "#FF0000", label: "CANCELLED" },
// ];

// const orderStatusColor: any = {
//   PENDING: { color: "#FFA500", label: "PENDING" },
//   CONFIRMED: { color: "#F5BCBA", label: "CONFIRMED" },
//   PLACED: { color: "#F5BCBA", label: "PLACED" },
//   SHIPPED: { color: "#1E90FF", label: "SHIPPED" },
//   DELIVERED: { color: "#32CD32", label: "DELIVERED" },
//   CANCELLED: { color: "#FF0000", label: "CANCELLED" },
// };

// // Convert ANY backend shape into a safe array
// function normalizeOrders(data: any): Order[] {
//   if (!data) return [];
//   if (Array.isArray(data)) return data;
//   if (Array.isArray(data?.content)) return data.content; // Spring Page
//   if (Array.isArray(data?.orders)) return data.orders; // wrapper {orders:[]}
//   if (Array.isArray(data?.data)) return data.data; // wrapper {data:[]}
//   return [data]; // single object -> wrap
// }

// export default function OrderTable() {
//   const { sellerOrder } = useAppSelector((store) => store);
//   const dispatch = useAppDispatch();
//   const jwt = localStorage.getItem("jwt") || "";

//   // Filters (all optional)
//   const [searchBy, setSearchBy] = React.useState<"orderId" | "email">("orderId");
//   const [searchValue, setSearchValue] = React.useState<string>("");

//   const [statusFilter, setStatusFilter] = React.useState<string>("ALL");
//   const [fromDate, setFromDate] = React.useState<string>("");
//   const [toDate, setToDate] = React.useState<string>("");

//   // Search results stored separately, so default page remains same
//   const [filteredOrders, setFilteredOrders] = React.useState<Order[] | null>(
//     null
//   );
//   const [searchLoading, setSearchLoading] = React.useState<boolean>(false);

//   const [anchorEl, setAnchorEl] = React.useState<{
//     [key: number]: HTMLElement | null;
//   }>({});

//   const handleClick = (
//     event: React.MouseEvent<HTMLElement>,
//     orderId: number
//   ) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: event.currentTarget }));
//   };

//   const handleClose = (orderId: number) => {
//     setAnchorEl((prev) => ({ ...prev, [orderId]: null }));
//   };

//   React.useEffect(() => {
//     // Default behavior (as before)
//     dispatch(fetchSellerOrders(jwt));
//   }, [dispatch, jwt]);

//   const handleUpdateOrder = (orderId: number, orderStatusVal: any) => {
//     dispatch(
//       updateOrderStatus({
//         jwt,
//         orderId,
//         orderStatus: orderStatusVal,
//       })
//     );
//     handleClose(orderId);
//   };

//   const hasAnyFilter =
//     (searchValue && searchValue.trim().length > 0) ||
//     statusFilter !== "ALL" ||
//     !!fromDate ||
//     !!toDate;

//   const handleApplyFilters = async () => {
//     // No filter => behave exactly like before
//     if (!hasAnyFilter) {
//       setFilteredOrders(null);
//       dispatch(fetchSellerOrders(jwt));
//       return;
//     }

//     // validate date range
//     if (fromDate && toDate && fromDate > toDate) {
//       alert("Invalid date range: 'From' date cannot be after 'To' date.");
//       return;
//     }

//     setSearchLoading(true);

//     try {
//       const params = new URLSearchParams();

//       // ✅ FIX: never send status when 'ALL' is selected (even if spaces/case issues)
//       // const normalizedStatus = (statusFilter || "").trim().toUpperCase();
//       // if (normalizedStatus && normalizedStatus !== "ALL") {
//       //   params.append("status", normalizedStatus);
//       // }

//       const normalizedStatus = String(statusFilter || "ALL").trim().toUpperCase();

//       // ✅ hard guarantee: NEVER send status when ALL
//       if (normalizedStatus === "ALL") {
//         params.delete("status");
//       } else {
//         params.set("status", normalizedStatus);
//       }

//       if (fromDate) params.append("from", fromDate);
//       if (toDate) params.append("to", toDate);

//       // Search value is optional
//       if (searchBy === "orderId") {
//         if (searchValue.trim()) params.append("orderId", searchValue.trim());

//         const res = await api.get(`/seller/orders/search?${params.toString()}`, {
//           headers: { Authorization: `Bearer ${jwt}` },
//         });

//         setFilteredOrders(normalizeOrders(res.data));
//       } else {
//         if (searchValue.trim()) params.append("email", searchValue.trim());

//         const res = await api.get(
//           `/seller/orders/search-by-user?${params.toString()}`,
//           { headers: { Authorization: `Bearer ${jwt}` } }
//         );

//         setFilteredOrders(normalizeOrders(res.data));
//       }
//     } catch (err: any) {
//       console.log("Search error", err?.response || err);
//       alert(err?.response?.data?.message || "Failed to search orders");
//       setFilteredOrders([]); // safe fallback
//     } finally {
//       setSearchLoading(false);
//     }
//   };

//   const handleClearFilters = () => {
//     setSearchBy("orderId");
//     setSearchValue("");
//     setStatusFilter("ALL");
//     setFromDate("");
//     setToDate("");
//     setFilteredOrders(null);

//     // restore original behavior
//     dispatch(fetchSellerOrders(jwt));
//   };

//   // Always safe array
//   const ordersToShow: Order[] = React.useMemo(() => {
//     if (Array.isArray(filteredOrders)) return filteredOrders;
//     if (Array.isArray(sellerOrder?.orders)) return sellerOrder.orders;
//     return [];
//   }, [filteredOrders, sellerOrder?.orders]);

//   const isLoading = Boolean(sellerOrder?.loading) || searchLoading;

//   return (
//     <>
//       <h1 className="pb-5 font-bold text-xl">All Orders</h1>

//       {/* Filter Bar */}
//       <Paper className="mb-4" sx={{ p: 2 }}>
//         <Stack
//           direction={{ xs: "column", md: "row" }}
//           spacing={2}
//           alignItems={{ md: "center" }}
//           sx={{ width: "100%" }} // ✅ take full width so input can expand (reduces gap)
//         >
//           <FormControl size="small" sx={{ minWidth: 160 }}>
//             <InputLabel id="search-by-label">Search By</InputLabel>
//             <Select
//               labelId="search-by-label"
//               value={searchBy}
//               label="Search By"
//               onChange={(e) => {
//                 setSearchBy(e.target.value as any);
//                 setSearchValue("");
//               }}
//             >
//               <MenuItem value="orderId">Order ID</MenuItem>
//               <MenuItem value="email">Email</MenuItem>
//             </Select>
//           </FormControl>

//           {/* ✅ Updated: no spinner, but numeric-only when Order ID */}
//           <TextField
//             size="small"
//             label={
//               searchBy === "orderId" ? "Order ID (optional)" : "Email (optional)"
//             }
//             value={searchValue}
//             onChange={(e) => {
//               const val = e.target.value;
//               if (searchBy === "orderId") {
//                 // allow only digits (no spinner)
//                 setSearchValue(val.replace(/\D/g, ""));
//               } else {
//                 setSearchValue(val);
//               }
//             }}
//             placeholder={searchBy === "orderId" ? "Enter order id" : "Enter email"}
//             inputProps={
//               searchBy === "orderId"
//                 ? { inputMode: "numeric", pattern: "[0-9]*" }
//                 : undefined
//             }
//             sx={{ minWidth: 120, flexGrow: 1 }} // ✅ wider + aligns with table width
//           />

//           <FormControl size="small" sx={{ minWidth: 180 }}>
//             <InputLabel id="status-label">Order Status</InputLabel>
//             <Select
//               labelId="status-label"
//               value={statusFilter}
//               label="Order Status"
//               // onChange={(e) => setStatusFilter(e.target.value)}
//               onChange={(e) => setStatusFilter(String(e.target.value).trim().toUpperCase() || "ALL")}
//             >
//               <MenuItem value="ALL">All</MenuItem>
//               {orderStatus.map((s) => (
//                 <MenuItem key={s.label} value={s.label}>
//                   {s.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <TextField
//             size="small"
//             label="From (optional)"
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//           />

//           <TextField
//             size="small"
//             label="To (optional)"
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             InputLabelProps={{ shrink: true }}
//           />

//           <Box sx={{ display: "flex", gap: 1 }}>
//             <Button
//               variant="contained"
//               onClick={handleApplyFilters}
//               disabled={isLoading}
//             >
//               Apply
//             </Button>
//             <Button
//               variant="outlined"
//               onClick={handleClearFilters}
//               disabled={isLoading}
//             >
//               Clear
//             </Button>
//           </Box>
//         </Stack>
//       </Paper>

//       <TableContainer component={Paper}>
//         <Table sx={{ minWidth: 700 }} aria-label="customized table">
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Order Id</StyledTableCell>
//               <StyledTableCell>Products</StyledTableCell>
//               <StyledTableCell>Shipping Address</StyledTableCell>
//               <StyledTableCell align="right">Order Status</StyledTableCell>
//               <StyledTableCell align="right">Update</StyledTableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {ordersToShow.map((item: Order) => (
//               <StyledTableRow key={item.id}>
//                 <StyledTableCell align="left">{item.id}</StyledTableCell>

//                 <StyledTableCell component="th" scope="row">
//                   <div className="flex gap-1 flex-wrap">
//                     {item.orderItems?.map((orderItem: OrderItem) => (
//                       <div key={orderItem.id} className="flex gap-5">
//                         <img
//                           className="w-20 rounded-md"
//                           src={orderItem.product?.images?.[0]}
//                           alt=""
//                         />
//                         <div className="flex flex-col justify-between py-2">
//                           <h1>Title: {orderItem.product?.title}</h1>
//                           <h1>Price: Rs.{orderItem.product?.sellingPrice}</h1>
//                           <h1>Color: {orderItem.product?.color}</h1>
//                           <h1>Size: {orderItem.size}</h1>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </StyledTableCell>

//                 <StyledTableCell>
//                   <div className="flex flex-col gap-y-2">
//                     <h1>{item.shippingAddress?.name}</h1>
//                     <h1>
//                       {item.shippingAddress?.address},{" "}
//                       {item.shippingAddress?.city}
//                     </h1>
//                     <h1>
//                       {item.shippingAddress?.state} -{" "}
//                       {item.shippingAddress?.pinCode}
//                     </h1>
//                     <h1>
//                       <strong>Mobile:</strong> {item.shippingAddress?.mobile}
//                     </h1>
//                   </div>
//                 </StyledTableCell>

//                 <StyledTableCell
//                   sx={{ color: orderStatusColor[item.orderStatus]?.color }}
//                   align="center"
//                 >
//                   <Box
//                     sx={{
//                       borderColor: orderStatusColor[item.orderStatus]?.color,
//                     }}
//                     className="border px-2 py-1 rounded-full text-xs"
//                   >
//                     {item.orderStatus}
//                   </Box>
//                 </StyledTableCell>

//                 <StyledTableCell align="right">
//                   <Button
//                     size="small"
//                     onClick={(e) => handleClick(e, item.id)}
//                     color="primary"
//                     className="bg-primary-color"
//                     disabled={isLoading}
//                   >
//                     Status
//                   </Button>

//                   <Menu
//                     id={`status-menu ${item.id}`}
//                     anchorEl={anchorEl[item.id]}
//                     open={Boolean(anchorEl[item.id])}
//                     onClose={() => handleClose(item.id)}
//                     MenuListProps={{
//                       "aria-labelledby": `status-menu ${item.id}`,
//                     }}
//                   >
//                     {orderStatus.map((s) => (
//                       <MenuItem
//                         key={s.label}
//                         onClick={() => handleUpdateOrder(item.id, s.label)}
//                       >
//                         {s.label}
//                       </MenuItem>
//                     ))}
//                   </Menu>
//                 </StyledTableCell>
//               </StyledTableRow>
//             ))}

//             {ordersToShow.length === 0 && !isLoading && (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   No orders found
//                 </TableCell>
//               </TableRow>
//             )}

//             {isLoading && (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   Loading...
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </>
//   );
// }


import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  styled,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Stack,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import {
  fetchSellerOrders,
  updateOrderStatus,
} from "../../../Redux Toolkit/Seller/sellerOrderSlice";
import { Order, OrderItem } from "../../../types/orderTypes";
import { api } from "../../../Config/Api";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:last-child td, &:last-child th": { border: 0 },
}));

const orderStatus = [
  { color: "#FFA500", label: "PENDING" },
  { color: "#F5BCBA", label: "PLACED" },
  { color: "#F5BCBA", label: "CONFIRMED" },
  { color: "#1E90FF", label: "SHIPPED" },
  { color: "#32CD32", label: "DELIVERED" },
  { color: "#FF0000", label: "CANCELLED" },
];

const orderStatusColor: any = {
  PENDING: { color: "#FFA500", label: "PENDING" },
  CONFIRMED: { color: "#F5BCBA", label: "CONFIRMED" },
  PLACED: { color: "#F5BCBA", label: "PLACED" },
  SHIPPED: { color: "#1E90FF", label: "SHIPPED" },
  DELIVERED: { color: "#32CD32", label: "DELIVERED" },
  CANCELLED: { color: "#FF0000", label: "CANCELLED" },
};

// Convert ANY backend shape into a safe array
function normalizeOrders(data: any): Order[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.content)) return data.content; // Spring Page
  if (Array.isArray(data?.orders)) return data.orders; // wrapper {orders:[]}
  if (Array.isArray(data?.data)) return data.data; // wrapper {data:[]}
  return [data]; // single object -> wrap
}

export default function OrderTable() {
  const { sellerOrder } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();
  const jwt = localStorage.getItem("jwt") || "";

  // Filters (all optional)
  const [searchBy, setSearchBy] = React.useState<"orderId" | "email">("orderId");
  const [searchValue, setSearchValue] = React.useState<string>("");

  const [statusFilter, setStatusFilter] = React.useState<string>("ALL");
  const [fromDate, setFromDate] = React.useState<string>("");
  const [toDate, setToDate] = React.useState<string>("");

  // Search results stored separately, so default page remains same
  const [filteredOrders, setFilteredOrders] = React.useState<Order[] | null>(
    null
  );
  const [searchLoading, setSearchLoading] = React.useState<boolean>(false);

  const [anchorEl, setAnchorEl] = React.useState<{
    [key: number]: HTMLElement | null;
  }>({});

  const openOrderInNewTab = (orderId: number) => {
    window.open(`/seller/orders/view/${orderId}`, "_blank", "noopener,noreferrer");
  };

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    orderId: number
  ) => {
    setAnchorEl((prev) => ({ ...prev, [orderId]: event.currentTarget }));
  };

  const handleClose = (orderId: number) => {
    setAnchorEl((prev) => ({ ...prev, [orderId]: null }));
  };

  React.useEffect(() => {
    // Default behavior (as before)
    dispatch(fetchSellerOrders(jwt));
  }, [dispatch, jwt]);

  const handleUpdateOrder = (orderId: number, orderStatusVal: any) => {
    dispatch(
      updateOrderStatus({
        jwt,
        orderId,
        orderStatus: orderStatusVal,
      })
    );
    handleClose(orderId);
  };

  const hasAnyFilter =
    (searchValue && searchValue.trim().length > 0) ||
    statusFilter !== "ALL" ||
    !!fromDate ||
    !!toDate;

  const handleApplyFilters = async () => {
    // No filter => behave exactly like before
    if (!hasAnyFilter) {
      setFilteredOrders(null);
      dispatch(fetchSellerOrders(jwt));
      return;
    }

    // validate date range
    if (fromDate && toDate && fromDate > toDate) {
      alert("Invalid date range: 'From' date cannot be after 'To' date.");
      return;
    }

    setSearchLoading(true);

    try {
      const params = new URLSearchParams();

      // never send status when ALL selected
      const normalizedStatus = String(statusFilter || "ALL")
        .trim()
        .toUpperCase();
      if (normalizedStatus !== "ALL") params.append("status", normalizedStatus);

      if (fromDate) params.append("from", fromDate);
      if (toDate) params.append("to", toDate);

      // Search value is optional
      if (searchBy === "orderId") {
        if (searchValue.trim()) params.append("orderId", searchValue.trim());

        const res = await api.get(`/seller/orders/search?${params.toString()}`, {
          headers: { Authorization: `Bearer ${jwt}` },
        });

        setFilteredOrders(normalizeOrders(res.data));
      } else {
        if (searchValue.trim()) params.append("email", searchValue.trim());

        const res = await api.get(
          `/seller/orders/search-by-user?${params.toString()}`,
          { headers: { Authorization: `Bearer ${jwt}` } }
        );

        setFilteredOrders(normalizeOrders(res.data));
      }
    } catch (err: any) {
      console.log("Search error", err?.response || err);
      alert(err?.response?.data?.message || "Failed to search orders");
      setFilteredOrders([]); // safe fallback
    } finally {
      setSearchLoading(false);
    }
  };

  const handleClearFilters = () => {
    setSearchBy("orderId");
    setSearchValue("");
    setStatusFilter("ALL");
    setFromDate("");
    setToDate("");
    setFilteredOrders(null);

    // restore original behavior
    dispatch(fetchSellerOrders(jwt));
  };

  // Always safe array
  const ordersToShow: Order[] = React.useMemo(() => {
    if (Array.isArray(filteredOrders)) return filteredOrders;
    if (Array.isArray(sellerOrder?.orders)) return sellerOrder.orders;
    return [];
  }, [filteredOrders, sellerOrder?.orders]);

  const isLoading = Boolean(sellerOrder?.loading) || searchLoading;

  return (
    <>
      <h1 className="pb-5 font-bold text-xl">All Orders</h1>

      {/* Filter Bar */}
      <Paper className="mb-4" sx={{ p: 2 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ md: "center" }}
          sx={{ width: "100%" }}
        >
          <FormControl size="small" sx={{ minWidth: 160 }}>
            <InputLabel id="search-by-label">Search By</InputLabel>
            <Select
              labelId="search-by-label"
              value={searchBy}
              label="Search By"
              onChange={(e) => {
                setSearchBy(e.target.value as any);
                setSearchValue("");
              }}
            >
              <MenuItem value="orderId">Order ID</MenuItem>
              <MenuItem value="email">Email</MenuItem>
            </Select>
          </FormControl>

          {/* no spinner, numeric-only when Order ID */}
          <TextField
            size="small"
            label={
              searchBy === "orderId" ? "Order ID (optional)" : "Email (optional)"
            }
            value={searchValue}
            onChange={(e) => {
              const val = e.target.value;
              if (searchBy === "orderId") {
                setSearchValue(val.replace(/\D/g, ""));
              } else {
                setSearchValue(val);
              }
            }}
            placeholder={searchBy === "orderId" ? "Enter order id" : "Enter email"}
            inputProps={
              searchBy === "orderId"
                ? { inputMode: "numeric", pattern: "[0-9]*" }
                : undefined
            }
            sx={{ minWidth: 120, flexGrow: 1 }}
          />

          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel id="status-label">Order Status</InputLabel>
            <Select
              labelId="status-label"
              value={statusFilter}
              label="Order Status"
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <MenuItem value="ALL">All</MenuItem>
              {orderStatus.map((s) => (
                <MenuItem key={s.label} value={s.label}>
                  {s.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            size="small"
            label="From (optional)"
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            size="small"
            label="To (optional)"
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              variant="contained"
              onClick={handleApplyFilters}
              disabled={isLoading}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              onClick={handleClearFilters}
              disabled={isLoading}
            >
              Clear
            </Button>
          </Box>
        </Stack>
      </Paper>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Order Id</StyledTableCell>
              <StyledTableCell>Products</StyledTableCell>
              <StyledTableCell>Shipping Address</StyledTableCell>
              <StyledTableCell align="right">Order Status</StyledTableCell>
              <StyledTableCell align="right">Update</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {ordersToShow.map((item: Order) => (
              <StyledTableRow
                key={item.id}
                hover
                onClick={() => openOrderInNewTab(item.id)}
                sx={{ cursor: "pointer" }}
              >
                <StyledTableCell align="left">{item.id}</StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <div className="flex gap-1 flex-wrap">
                    {item.orderItems?.map((orderItem: OrderItem) => (
                      <div key={orderItem.id} className="flex gap-5">
                        <img
                          className="w-20 rounded-md"
                          src={orderItem.product?.images?.[0]}
                          alt=""
                        />
                        <div className="flex flex-col justify-between py-2">
                          <h1>Title: {orderItem.product?.title}</h1>
                          <h1>Price: Rs.{orderItem.product?.sellingPrice}</h1>
                          <h1>Color: {orderItem.product?.color}</h1>
                          <h1>Size: {orderItem.size}</h1>
                          <h1>Quantity: {orderItem.quantity}</h1>
                        </div>
                      </div>
                    ))}
                  </div>
                </StyledTableCell>

                <StyledTableCell>
                  <div className="flex flex-col gap-y-2">
                    <h1>{item.shippingAddress?.name}</h1>
                    <h1>
                      {item.shippingAddress?.address},{" "}
                      {item.shippingAddress?.city}
                    </h1>
                    <h1>
                      {item.shippingAddress?.state} -{" "}
                      {item.shippingAddress?.pinCode}
                    </h1>
                    <h1>
                      <strong>Mobile:</strong> {item.shippingAddress?.mobile}
                    </h1>
                  </div>
                </StyledTableCell>

                <StyledTableCell
                  sx={{ color: orderStatusColor[item.orderStatus]?.color }}
                  align="center"
                >
                  <Box
                    sx={{
                      borderColor: orderStatusColor[item.orderStatus]?.color,
                    }}
                    className="border px-2 py-1 rounded-full text-xs"
                  >
                    {item.orderStatus}
                  </Box>
                </StyledTableCell>

                <StyledTableCell align="right">
                  <Button
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClick(e, item.id);
                    }}
                    color="primary"
                    className="bg-primary-color"
                    disabled={isLoading}
                  >
                    Status
                  </Button>

                  <Menu
                    id={`status-menu ${item.id}`}
                    anchorEl={anchorEl[item.id]}
                    open={Boolean(anchorEl[item.id])}
                    onClose={() => handleClose(item.id)}
                    MenuListProps={{
                      "aria-labelledby": `status-menu ${item.id}`,
                    }}
                  >
                    {orderStatus.map((s) => (
                      <MenuItem
                        key={s.label}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleUpdateOrder(item.id, s.label);
                        }}
                      >
                        {s.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </StyledTableCell>
              </StyledTableRow>
            ))}

            {ordersToShow.length === 0 && !isLoading && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No orders found
                </TableCell>
              </TableRow>
            )}

            {isLoading && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}